import { render, staticRenderFns } from "./PageHeaderCount.vue?vue&type=template&id=0106c493"
import script from "./PageHeaderCount.vue?vue&type=script&lang=js"
export * from "./PageHeaderCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports